import { render, staticRenderFns } from "./VentaDiariaComponent.vue?vue&type=template&id=8e06c20a"
import script from "./VentaDiariaComponent.vue?vue&type=script&lang=js"
export * from "./VentaDiariaComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports